import * as api from "../Api";

export const locationDefaultHistory = () => async (dispatch) => {
  try {
    const { data } = await api.getLocationDefaultStockHistory();
    dispatch({ type: "LOCATION_DEFAULT_STOCK_HISTORY", payload: data });
  } catch (error) {}
};
